<template>
    <v-card
        block
        outlined
        elevation="0"
        :href="(item.logoFile) ? item.logoFile.url : item.thumbnail.url"
        target="_blank"
        class="logo-card"
    >
        <div class="image">
            <v-img
                :src="item.thumbnail.url"
                v-if="item.thumbnail"
            ></v-img>
            <p v-else class="icon mb-0 text-center"><v-icon color="primary">fal fa-image</v-icon></p>
        </div>
        <span class="d-block px-3 py-3 text-center">{{ item.title }}</span>
        <v-card-actions class="align-center grey lighten-3">
            <v-btn text small color="primary">Download</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon color="primary"><v-icon>fal fa-download</v-icon></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "LogoCard",
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
